import React, { useState, useEffect, useCallback } from 'react';
import { availabilityAPI } from '../services/api';
import './GoLiveToggle.css';

const GoLiveToggle = () => {
  const [isLive, setIsLive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await availabilityAPI.getMyStatus();
        const status = res.data?.availability?.availability_status;
        const instantEnabled = res.data?.availability?.instant_book_enabled;
        setIsLive(status === 'available' && instantEnabled);
      } catch (err) {
        // Silent fail - default to off
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, []);

  // Heartbeat every 5 minutes while live
  useEffect(() => {
    if (!isLive) return;
    const interval = setInterval(() => {
      availabilityAPI.heartbeat().catch(() => {});
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isLive]);

  const handleToggle = async () => {
    try {
      setLoading(true);
      if (isLive) {
        // Going offline
        await availabilityAPI.updateStatus({ availability_status: 'not_accepting' });
        setIsLive(false);
      } else {
        // Going live
        await availabilityAPI.updateStatus({ availability_status: 'available' });
        await availabilityAPI.updateInstantBook({ instant_book_enabled: true });
        setIsLive(true);
      }
    } catch (err) {
      alert('Failed to update status. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return null;

  return (
    <button
      className={`go-live-toggle ${isLive ? 'live' : 'offline'}`}
      onClick={handleToggle}
      title={isLive ? 'You are live — homeowners can book you' : 'Go live — accept instant bookings'}
    >
      <span className={`live-dot ${isLive ? 'pulse' : ''}`}></span>
      <span className="live-text">{isLive ? 'Live' : 'Offline'}</span>
    </button>
  );
};

export default GoLiveToggle;
